/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinancialGroupRequest
 */
export interface FinancialGroupRequest {
    /**
     * the unique identifier of the financial group
     * @type {string}
     * @memberof FinancialGroupRequest
     */
    id?: string;
    /**
     * the code of financial group
     * @type {string}
     * @memberof FinancialGroupRequest
     */
    groupCode?: string;
    /**
     * the title of financial group
     * @type {string}
     * @memberof FinancialGroupRequest
     */
    groupTitle?: string;
    /**
     * the iban of financial group
     * @type {string}
     * @memberof FinancialGroupRequest
     */
    iban?: string;
}

/**
 * Check if a given object implements the FinancialGroupRequest interface.
 */
export function instanceOfFinancialGroupRequest(value: object): value is FinancialGroupRequest {
    return true;
}

export function FinancialGroupRequestFromJSON(json: any): FinancialGroupRequest {
    return FinancialGroupRequestFromJSONTyped(json, false);
}

export function FinancialGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'groupCode': json['groupCode'] == null ? undefined : json['groupCode'],
        'groupTitle': json['groupTitle'] == null ? undefined : json['groupTitle'],
        'iban': json['iban'] == null ? undefined : json['iban'],
    };
}

export function FinancialGroupRequestToJSON(json: any): FinancialGroupRequest {
    return FinancialGroupRequestToJSONTyped(json, false);
}

export function FinancialGroupRequestToJSONTyped(value?: FinancialGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'groupCode': value['groupCode'],
        'groupTitle': value['groupTitle'],
        'iban': value['iban'],
    };
}

